import { useState } from "react";

export const useStepper = (initialState: number = 0) => {
    const [step, setStep] = useState(initialState);

    const next = () => setStep(step => step + 1);

    const back = () => setStep(step => step - 1);

    const reset = () => setStep(initialState);

    return {
        step,
        next,
        back,
        reset
    };
};

export default useStepper;
